import atomize from "@quarkly/atomize";
export default atomize.div({
  name: "Box",
  effects: {
    hover: ":hover",
    firstChild: ":first-child",
    lastChild: ":last-child",
    onlyChild: ":only-child",
    firstOfType: ":first-of-type",
    lastOfType: ":last-of-type",
    onlyOfType: ":only-of-type",
    before: ":before",
    after: ":after",
    empty: ":empty"
  },
  normalize: true,
  mixins: true,
  description: {
    en: "box element — auxiliary container with arbitrary sizes for different tasks",
    ru: "Элемент box — вспомогательный контейнер с произвольными размерами для различных задач"
  },
  propInfo: {
    as: {
      type: "string",
      category: "Main",
      control: "select",
      variants: ["article", "aside", "blockquote", "div", "figcaption", "figure", "footer", "header", "hgroup", "main", "nav", "section"]
    }
  }
}, {
  as: "div",
  "min-width": "16px",
  "min-height": "16px"
});